<template>
  <v-fade-transition class="leave-absolute" v-if="modelValue">
    <div class="no-data-overlay">
      {{ message }}
    </div>
  </v-fade-transition>
</template>


<script>
export default {
  name: "NoDataOverlay",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "No data available yet.",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  beforeUnmount() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.no-data-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  color: #333;
  font-size: 1.5rem;
}
</style>